import React, { useState, useMemo, useEffect } from "react";
import moment from "moment-timezone";
import Pagination from "./Pagination/Pagination";
import copy from "copy-to-clipboard";
import api, { uploadImage, requestData, apiUrl } from "../services/requests";
import EditarImagem from "./EditarImagem";

const { criarCarteiras } = require("../services/requests");

const PainelMobile = ({
  carteiras,
  setCarteiras,
  isAdmin,
  getCarteiras,
  filtragem,
  activeTab,
  pagination = {},
  currentFilters,
}) => {
  const { page, limit, setPage, setLimit, totalCount } = pagination;

  const date = new Date();
  const url = `https://www.uniscestudantil.org.br/carteiras/`;
  const newDate = moment(date).locale("pt-br").format("YYYY-MM-DD HH:mm:ss");

  const [save, setSave] = useState(false);
  const [imagens, setImagens] = useState("");
  const [gestores, setGestores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const setImagem = (id, file) => {
    setImagens((prevState) => ({
      ...prevState,
      [id]: file,
    }));
  };

  const handleImageUpload = async (carteiraId, file) => {
    try {
      if (file) {
        const upload = "/upload-image";
        const formData = new FormData();
        formData.append("image", file);

        await uploadImage(upload, formData); // Faz o upload da imagem

        // Atualiza a carteira no banco com a nova URL da foto
        await api.patch(`/carteiras/editar/${carteiraId}`, {
          foto: `${apiUrl}/images/${file.name}`,
        });

        alert("Imagem atualizada com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao fazer upload da imagem:", error);
      alert("Erro ao atualizar a imagem.");
    }
  };

  const getGestores = async () => {
    const endpoint = "/user/all";
    const gestores = await requestData(endpoint);
    setGestores(gestores);
  };

  const handleInputChange = async (e, id) => {
    const { name, value } = e.target;

    if (name === "status") {
      await api.patch(`/carteiras/editar/status/${id}`, {
        status: value,
      });
    }

    setCarteiras((prevCarteiras) =>
      prevCarteiras.map((carteira) =>
        carteira.id === id ? { ...carteira, [name]: value } : carteira
      )
    );
  };

  const handleSave = async (e, id) => {
    const carteira = carteiras.find((carteira) => carteira.id === id);
    try {
      if (imagens[id] !== undefined) {
        const upload = "/upload-image";
        const formData = new FormData();
        formData.append("image", imagens[id]);
        await uploadImage(upload, formData);
      }

      await api.patch(`/carteiras/editar/${id}`, {
        ...carteira,
        nome: carteira.name,
        foto:
          imagens[id] === undefined
            ? carteira.foto
            : `${apiUrl}/images/${imagens[id].name}`,
      });

      getCarteiras(activeTab, null, page, limit);
      alert("Salvo com sucesso!");
    } catch (error) {
      console.log(error);
    }
  };

  function periodoDeRenovacao(carteira) {
    const dataHoje = newDate.split(" ")[0];
    const anoDataValidade = carteira.dataValidade.split("-")[0];
    const periodoRenovacao = new Date(anoDataValidade, 0, 1)
      .toISOString()
      .split("T")[0];
    const validadeCarteira = carteira.dataValidade.split("T")[0];
    return dataHoje >= periodoRenovacao && dataHoje <= validadeCarteira;
  }

  const handleClick = async (carteira) => {
    try {
      setIsLoading(true);
      const endpoint = "/carteiras/renovacao";
      await criarCarteiras(endpoint, {
        foto: carteira.foto,
        codigoUso: carteira.codigoUso,
        nome: carteira.name,
        instituicaoEnsino: carteira.instituicaoEnsino,
        curso: carteira.curso,
        cpf: carteira.cpf,
        rg: carteira.rg,
        dataNascimento: carteira.dataNascimento,
        user_id: carteira.user_id,
        email: carteira.email,
        telefone: carteira.telefone,
      });
      setTimeout(() => {
        getCarteiras(activeTab, null, page, limit);
        window.scrollTo(0, 0);
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      getGestores();
    }
  }, [isAdmin]);

  const copyToClipboard = (text) => {
    const url = `${window.location.origin}/carteiras/${text}`;
    copy(url);
  };

  return (
    <>
      <div className="flex items-center justify-center">
        <div className="flex items-center flex-col w-full">
          {carteiras.map((carteira) => (
            <div
              className="bg-[#aac5fc] rounded-2xl mb-2 w-full p-2"
              key={carteira.id}
            >
              <div className="flex items-center justify-around">
                <div className="flex items-center justify-center max-w-[200px] max-h-[300px] m-4 p-2">
                  <EditarImagem
                    img={imagens[carteira.id]}
                    handleImageUpload={handleImageUpload}
                    setImagem={setImagem}
                    imagemInicial={carteira.foto}
                    carteiraId={carteira.id}
                    save={save}
                    isRecepcionada={carteira.status === "Recepcionada"}
                  />
                </div>
                <select
                  id="status_carteira"
                  name="status"
                  value={carteira.status}
                  onChange={(e) => handleInputChange(e, carteira.id)}
                  disabled={carteira.status === "Expirada"}
                  readOnly
                  className={`p-2 m-2 h-12 border-none bg-white text-lg font-bold font-fira-sans disabled:bg-white`}
                  style={{
                    color:
                      carteira.status === "Recepcionada"
                        ? "black"
                        : carteira.status === "Validada"
                        ? "#4CC800"
                        : carteira.status === "Cancelada"
                        ? "red"
                        : "black",
                  }}
                >
                  <option style={{ color: "black" }} value="Recepcionada">
                    Recepcionada
                  </option>
                  <option style={{ color: "#4CC800" }} value="Validada">
                    Validada
                  </option>
                  <option disabled value="Renovação">
                    Renovação
                  </option>
                  <option style={{ color: "red" }} disabled value="Expirada">
                    Expirada
                  </option>
                  <option style={{ color: "red" }} value="Cancelada">
                    Cancelada
                  </option>
                </select>
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className="flex flex-col p-2 w-full">
                  <input
                    className="m-1 p-1 border-none font-bold rounded-md"
                    placeholder="NOME"
                    name="name"
                    value={carteira.name.toUpperCase()}
                    aria-label="Nome completo"
                    onChange={(e) => handleInputChange(e, carteira.id)}
                  />
                  <input
                    className="m-1 p-1 border-none font-bold rounded-md"
                    placeholder="INSTIUIÇÃO DE ENSINO"
                    name="instituicaoEnsino"
                    value={carteira.instituicaoEnsino.toUpperCase()}
                    onChange={(e) => handleInputChange(e, carteira.id)}
                  />
                  <input
                    className="m-1 p-1 border-none font-bold rounded-md"
                    placeholder="CURSO"
                    name="curso"
                    value={carteira.curso.toUpperCase()}
                    onChange={(e) => handleInputChange(e, carteira.id)}
                  />
                  <div className="flex w-full text-sm font-bold">
                    <label className="m-1 flex w-full justify-center items-center">
                      <span className="mr-1">CPF:</span>
                      <input
                        className="font-bold w-full p-1 border-none rounded-md"
                        name="cpf"
                        value={carteira.cpf}
                        onChange={(e) => handleInputChange(e, carteira.id)}
                      />
                    </label>
                  </div>
                  <div className="flex w-full text-sm font-bold">
                    <label className="m-1 flex w-full justify-center items-center">
                      <span className="mr-1">RG:</span>
                      <input
                        className="font-bold w-full p-1 border-none rounded-md"
                        placeholder=""
                        name="rg"
                        value={carteira.rg}
                        onChange={(e) => handleInputChange(e, carteira.id)}
                      />
                    </label>
                    <label className="m-1 flex w-full justify-center items-center">
                      <span className="mr-1">DN:</span>
                      <input
                        className="font-bold w-full p-1 border-none rounded-md"
                        placeholder=""
                        name="dataNascimento"
                        value={carteira.dataNascimento}
                        onChange={(e) => handleInputChange(e, carteira.id)}
                      />
                    </label>
                  </div>
                </div>
                <div className="flex justify-around w-full">
                  <a
                    className="text-center bg-blue-900 no-underline font-league-gothic text-2xl border-none text-white p-1 w-1/3 rounded-md mx-2"
                    href={`/carteiras/${carteira.id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    VISUALIZAR
                  </a>
                  {periodoDeRenovacao(carteira) === true ||
                  carteira.status === "Expirada" ? (
                    <button
                      className="text-center bg-red-600 text-white no-underline font-league-gothic text-2xl border-none p-1 w-1/3 rounded-md disabled:opacity-50 mx-2"
                      disabled={isLoading}
                      onClick={() => handleClick(carteira)}
                    >
                      RENOVAÇÃO{" "}
                    </button>
                  ) : (
                    <button
                      className="bg-yellow-500 font-league-gothic text-2xl border-none text-white w-1/3 p-1 rounded-md cursor-pointer mx-2"
                      onClick={() => copyToClipboard(carteira.id)}
                    >
                      URL
                    </button>
                  )}
                  <button
                    className="text-center bg-green-500 text-white no-underline font-league-gothic text-2xl border-none p-1 w-1/3 rounded-md"
                    onClick={(e) => {
                      handleSave(e, carteira.id);
                    }}
                  >
                    SALVAR{" "}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="Resultados"> {totalCount} Resultados encontrados </div>
      <Pagination
        className="pagination-bar"
        currentPage={page}
        totalCount={totalCount}
        pageSize={limit}
        onPageChange={(page) => {
          setPage(page);
          getCarteiras(activeTab, currentFilters, page, limit);
        }}
      />
    </>
  );
};

export default PainelMobile;
